import { useLocation } from "react-router-dom";
import classnames from "classnames";

import { EnvironmentWarningHeader } from "common/account/login/components";
import type { CustomOrgHeadersEnum } from "graphql_globals";

import LogoNav from "../logo_nav";
import Styles from "./index.module.scss";

type Props = {
  children: React.ReactNode;
  orgLogo?: string | null;
  orgName?: string | null;
  header?: CustomOrgHeadersEnum;
  readOnly?: boolean;
  hideWarningHeader?: boolean;
  headerClassName?: string;
};

export default function UnauthenticatedAppFrame({
  children,
  orgLogo,
  orgName,
  header,
  readOnly,
  headerClassName,
  hideWarningHeader,
}: Props) {
  const { pathname } = useLocation();

  return (
    <div className={Styles.container}>
      {!hideWarningHeader && <EnvironmentWarningHeader />}
      <div className={classnames(Styles.containerHeader, headerClassName)}>
        <LogoNav
          orgName={orgName}
          logoUrl={orgLogo}
          headerStyle={header}
          readOnly={readOnly || pathname === "/login"}
        />
      </div>
      <div className="AppContainer">{children}</div>
    </div>
  );
}
